// src/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://mdsvyutlbkbtzuhnskvg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1kc3Z5dXRsYmtidHp1aG5za3ZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTU3OTE1MjQsImV4cCI6MjAzMTM2NzUyNH0.8wPqoakddWgV2jZgzwUXO6oZ3bbSQIXr61AIsTNCyno'; // Replace with your Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
